import { Component, AfterViewInit, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import data from '../../video.json';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
export interface Video {
  ativo?: boolean;
  capa: string;
  category: string;
  gtm: string;
  src: string;
  titulo: string;
}

@Component({
  selector: 'app-playlist-videos',
  templateUrl: './playlist-videos.component.html',
  styleUrl: './playlist-videos.component.scss',
})
export class PlaylistVideosComponent implements AfterViewInit, OnInit {
  @Input() tituloVideo: string = 'Assista aos nossos tutoriais';
  constructor(private gtmService: GoogleTagManagerService, private route: ActivatedRoute) { }
  @ViewChild('elementoAlvo') elementoAlvo!: ElementRef;
  @Input('defaultCategory')
  public defaultCategory: undefined | string = '';

  private listVideo: any;
  private mainVideo: any;
  private title: any;
  public titulo: string = '';
  public gtm: string = '';
  public env = environment;
  public categories: any = [];
  public videos = data.main;
  public videoPrincipal = 'vantagens-aplicativo.mp4';
  public titleVideoPrincipal = 'vantagens-aplicativo.mp4';
  public video: any;
  public srcVideo = this.env.origin + '/midias/';
  public titleVideo: any;
  public titleParam: any
  param: any;
  id!: number;
  source: any;
  capa: string = this.videos[0].capa;
  urlParams = new URLSearchParams(location.search);


  ngOnInit(): void {

    this.gtm = 'gtm-vantagens';
    this.titulo = 'Vantagens do aplicativo';
    this.video = document.querySelector('[main-video]') as HTMLVideoElement;
    this.titleVideo = this.video.nextSibling as HTMLElement;

    if (!this.defaultCategory) return;

    this.videos = this.videos.filter(
      ({ category }: any) => category === this.defaultCategory

    );

    this.videos[0].ativo = true
    this.videoPrincipal = this.videos[0].src;
    this.capa = this.videos[0].capa;
    this.titleVideoPrincipal = this.videos[0].titulo;

  }

  ngAfterViewInit(): void {
    this.listVideo = document.querySelectorAll('.video-list .vid');
    this.title = document.querySelector('.main-video .title');
    this.mainVideo = document.querySelector('.main-video video');

    let attTitle = '';
    let attGtm = '';

    this.addEvent();
    this.makeCategories();

    this.titleParam = this.route.snapshot.paramMap.get('title');
    if (this.titleParam) {
      this.handleSendSrcVideo(this.titleParam);
    }
  }

  makeCategories(): void {
    const getCategories = data.main.map(({ category }) => {
      function captalize(string: string) {
        const str = string;
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
      return {
        title: captalize(category.replace(/[-]/gi, ' ')),
        value: category,
      };
    });

    const uniqueCategory = Array.from(
      new Set(getCategories.map((a) => a.title))
    ).map((title) => getCategories.find((a) => a.title === title));

    this.categories = uniqueCategory;
  }
  filterVideos(event: Event): void {
    const _category = (event.target as HTMLSelectElement).value;

    if (_category == 'null' || _category == 'all') {
      this.videos = data.main;
      return;
    }
    this.videos = data.main;
    this.videos = this.videos.filter(
      ({ category }: any) => category === _category
    );
  }
  addEvent() {
    const self = this;
    const onPlay = function () {
      self.onNavigation(self.gtm, self.titulo, 'play');
    };
    const onEnded = function () {
      self.onNavigation(self.gtm, self.titulo, 'fim');
    };

    this.mainVideo.removeEventListener('play', onEnded);
    this.mainVideo.removeEventListener('ended', onPlay);

    this.mainVideo.addEventListener('play', onPlay);
    this.mainVideo.addEventListener('ended', onEnded);
  }
  changeVideoAndSendGTM({
    element,
    clicou,
  }: {
    element: Video;
    clicou: string;
  }) {
    const srcVideo = this.env.origin + '/midias/';
    this.video = document.querySelector('[main-video]') as HTMLVideoElement;
    this.video.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
    const title = element.titulo;
    this.gtm = element.gtm;
    this.titulo = title;
    this.onNavigation(element.gtm, title, clicou);

    this.videos.forEach((el) => {
      el.ativo = false;
    });


    element.ativo = true;

    if (!!element.ativo) {
      this.capa = element.capa;
      this.titleVideo.textContent = element.titulo;
      this.video.src = this.srcVideo + element.src;
    }
  }
  handleSendSrcVideo(title: string) {


    this.elementoAlvo.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const tituloNormalizado = title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const filtrados = this.videos.filter((el) => {
      const tituloVideo = el.titulo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return tituloVideo.includes(tituloNormalizado);
    });



    if (filtrados.length > 0) {
      this.capa = filtrados[0].capa;
      filtrados[0].ativo = true
      this.titleVideo.textContent = filtrados[0].titulo;
      this.video.src = this.srcVideo + filtrados[0].src;
      console.log(this.video.src)
    } else {
      console.error("Vídeo não encontrado.");
    }
  }
  onNavigation(tag: string = '', titulo: string, event: string) {
    let id = 332950684;

    let gtmtag = {
      event: `${event}-${tag}`,
      name: `${event} ${titulo}`,
      id: id,
    };
    this.gtmService.pushTag(gtmtag);
  }
}
